<template>
  <div class="mx-0">
    <div class="bg-white rounded px-0">
      <ValidationObserver ref="publicOfficialsValidationObserver">
        <div class="py-3 px-1 pl-c-xl">
          <icon-view
            icon="fas fa-info-circle"
            icon-background="transparent"
            icon-color="#FF7058"
            icon-size="1.0625rem"
            :title="sectionDescription"
            variant="custom-icon"
          />
        </div>
        <div
          v-for="(item, index) in questionsData"
          :key="index"
          class="row mt-3 mb-4"
        >
          <div class="col-12 row">
            <div class="col-md-10 my-3 color-gray-6 font-16 text-justify">
              {{ getDynamicQuestion(item.question) }}
            </div>
            <div
              class="col-md-2 d-flex justify-content-end custom-radio-container"
            >
              <radio-button
                ref="radioButtonQuestionRef"
                :change-event="(value) => onChange(value, item.id)"
                class="radio-button-container"
                :class="{ 'read-only': isReadOnly }"
                :disabled="isReadOnly"
                :name="`question${item.id}`"
                :question-lists="getOptions(item.sortOrder)"
              />
            </div>
            <div class="col-12 row">
              <div class="col-md-10" />
              <div class="col-md-2 d-flex justify-content-end">
                <custom-error
                  v-if="
                    attemptedSaveHandler &&
                      getErrorMessageForQuestion[item.sortOrder]
                  "
                  class="mt-2"
                  :message="getErrorMessageForQuestion[item.sortOrder]"
                  :name="`error${item.id}`"
                  style="left: 35px;"
                  variant="no-border"
                />
              </div>
            </div>
            <div
              v-if="model.isFormerPublicOfficial && item.sortOrder === 3"
              class="col-12"
            >
              <hr />
            </div>
          </div>
          <div
            v-if="model.isActiveEducationDept && item.sortOrder === 1"
            class="col-12 row mt-3 mb-4"
          >
            <div class="col-md-6">
              <validation-provider v-slot="{ errors }" :rules="'required'">
                <div v-if="isReadOnly">
                  <label class="data-title mb-0">
                    Lugar de Trabajo:
                  </label>
                  <span class="data-content d-block text-justify">
                    {{ model.workPlaceEducationDept | empty }}
                  </span>
                </div>
                <custom-input
                  v-else
                  id="work-place-edu-dept-input"
                  v-model="model.workPlaceEducationDept"
                  class="custom-input-con"
                  custom-error-msg="Lugar de trabajo es requerido."
                  :error="errors[0]"
                  label="Lugar de Trabajo:"
                  placeholder="Escriba lugar de trabajo"
                />
              </validation-provider>
            </div>
            <div class="col-md-6">
              <validation-provider v-slot="{ errors }" :rules="'required'">
                <div v-if="isReadOnly">
                  <label class="data-title mb-0">
                    Título de Puesto:
                  </label>
                  <span class="data-content d-block text-justify">
                    {{ model.jobTitleEducationDept | empty }}
                  </span>
                </div>
                <custom-input
                  v-else
                  id="job-title-edu-dept-input"
                  v-model="model.jobTitleEducationDept"
                  class="custom-input-con"
                  custom-error-msg="Título de puesto es requerido."
                  :error="errors[0]"
                  label="Título de Puesto:"
                  placeholder="Escriba título de puesto"
                />
              </validation-provider>
            </div>
            <!--pregunta de dispensa para primera pregunta-->
            <div
              v-if="showSecretaryDispensa"
              class="col-md-12 col-sm-12 mr-md mt-3"
            >
              <label class="data-title mb-0">
                Dispensa del secretario de Educación.
              </label>
              <custom-callout
                :border-color="'secondary-3'"
                class-main="mt-3 rounded"
                :controlled="true"
                :has-toggle="false"
              >
                <div class="row mr-md-0 ml-n0 ml-md-n4 ml-0">
                  <div v-if="hasValidSecretaryFileName" class="col-6 my-2">
                    <div class="color-gray-6 font-14">Documento:</div>
                    <div class="color-black font-16 font-weight-bold">
                      {{ documentName | empty }}
                    </div>
                  </div>
                  <div v-if="hasValidSecretaryFileName" class="col-5 my-2">
                    <div class="color-gray-6 font-14">Archivo:</div>
                    <div class="color-black font-16 font-weight-bold">
                      {{ dispensaDocumentSecretary.filename | empty }}
                    </div>
                  </div>
                  <div
                    class="row align-items-center justify-content-center"
                    :class="hasValidSecretaryFileName ? 'col-1' : 'col-12'"
                  >
                    <validation-provider
                      v-slot="{ errors }"
                      :rules="getFileRules(model, dispensaDocumentSecretary)"
                    >
                      <custom-file-input
                        ref="dispensaFileSecretaryUpload"
                        accept="pdf"
                        add-text="Presione para cargar documento"
                        :attachment-id="model.dispensaDocumentSecretaryFileId"
                        :custom-error-msg="'El documento es requerido.'"
                        :disabled="isReadOnly"
                        display-style="normal"
                        :error="errors[0]"
                        name=" "
                        :on-download="onDownloadFile"
                        required
                        :value="dispensaDocumentSecretary.attachment"
                        @input="onChangeDispensaFileSecretary"
                      />
                    </validation-provider>
                  </div>
                </div>
              </custom-callout>
            </div>
            <!--fin pregunta de dispensa para primera pregunta-->
          </div>
          <div
            v-if="model.isActiveOtherDept && item.sortOrder === 2"
            class="col-12 row mt-3 mb-4"
          >
            <div class="col-md-6">
              <validation-provider v-slot="{ errors }" :rules="'required'">
                <div v-if="isReadOnly">
                  <label class="data-title mb-0">
                    Lugar de Trabajo:
                  </label>
                  <span class="data-content d-block text-justify">
                    {{ model.workPlaceOtherDept | empty }}
                  </span>
                </div>
                <custom-input
                  v-else
                  id="work-place-other-dept-input"
                  v-model="model.workPlaceOtherDept"
                  class="custom-input-con"
                  custom-error-msg="Lugar de trabajo es requerido."
                  :error="errors[0]"
                  label="Lugar de Trabajo:"
                  placeholder="Escriba lugar de trabajo"
                />
              </validation-provider>
            </div>
            <div class="col-md-6">
              <validation-provider v-slot="{ errors }" :rules="'required'">
                <div v-if="isReadOnly">
                  <label class="data-title mb-0">
                    Título de Puesto:
                  </label>
                  <span class="data-content d-block text-justify">
                    {{ model.jobTitleOtherDept | empty }}
                  </span>
                </div>
                <custom-input
                  v-else
                  id="job-title-other-dept-input"
                  v-model="model.jobTitleOtherDept"
                  class="custom-input-con"
                  custom-error-msg="Título de puesto es requerido."
                  :error="errors[0]"
                  label="Título de Puesto:"
                  placeholder="Escriba título de puesto"
                />
              </validation-provider>
            </div>
            <div
              v-if="
                !model.isNotApplyChecked &&
                  (hasValidFileName || isPending || isDenied)
              "
              class="col-md-12 col-sm-12 mr-md mt-3"
            >
              <label class="data-title mb-0">
                Dispensa o consentimiento escrito del rector o presidente de
                Universidad:
              </label>
              <custom-callout
                :border-color="'secondary-3'"
                class-main="mt-3 rounded"
                :controlled="true"
                :has-toggle="false"
              >
                <div class="row mr-md-0 ml-n0 ml-md-n4 ml-0">
                  <div v-if="hasValidFileName" class="col-6 my-2">
                    <div class="color-gray-6 font-14">Documento:</div>
                    <div class="color-black font-16 font-weight-bold">
                      {{ documentName | empty }}
                    </div>
                  </div>
                  <div v-if="hasValidFileName" class="col-5 my-2">
                    <div class="color-gray-6 font-14">Archivo:</div>
                    <div class="color-black font-16 font-weight-bold">
                      {{ dispensaDocument.filename | empty }}
                    </div>
                  </div>
                  <div
                    class="row align-items-center justify-content-center"
                    :class="hasValidFileName ? 'col-1' : 'col-12'"
                  >
                    <validation-provider
                      v-slot="{ errors }"
                      :rules="getFileRules(model, dispensaDocument)"
                    >
                      <custom-file-input
                        ref="dispensaFileUpload"
                        accept="pdf"
                        add-text="Presione para cargar documento"
                        :attachment-id="model.dispensaDocumentFileId"
                        :custom-error-msg="'El documento es requerido.'"
                        :disabled="isReadOnly"
                        display-style="normal"
                        :error="errors[0]"
                        name=" "
                        :on-download="onDownloadFile"
                        required
                        :value="dispensaDocument.attachment"
                        @input="onChangeDispensaFile"
                      />
                    </validation-provider>
                  </div>
                </div>
              </custom-callout>
            </div>
            <div class="col-md-12 col-sm-12 mt-3">
              <check-box
                v-if="!isReadOnly"
                v-model="model.isNotApplyChecked"
                class="checkbox"
                text="No aplica"
                @input="onChangeIsNotApplyChecked"
              />
            </div>
          </div>
          <div
            v-if="model.isFormerPublicOfficial && item.sortOrder === 3"
            class="col-12 row mt-3 mb-4"
          >
            <div class="col-md-10 my-3 color-gray-6 font-16 text-justify">
              ¿Han transcurrido dos (2) años siguientes a la fecha de
              terminación de su empleo gubernamental?
            </div>
            <div
              class="col-md-2 d-flex justify-content-end custom-radio-container"
            >
              <radio-button
                ref="radioButtonHasTwoYearsPassedRef"
                :change-event="onChangeHasTwoYearsPassed"
                class="radio-button-container"
                :class="{ 'read-only': isReadOnly }"
                :disabled="isReadOnly"
                :name="'rbHasTwoYearsPassed'"
                :question-lists="optionsHasTwoYearsPassed"
              />
            </div>
            <div class="col-12 row">
              <div class="col-md-10" />
              <div class="col-md-2 d-flex justify-content-end">
                <custom-error
                  v-if="
                    attemptedTwoYearsSaveHandler && showErrorHasTwoYearsPassed
                  "
                  class="mt-2"
                  :message="'Favor marcar Si o No.'"
                  style="left: 35px;"
                  variant="no-border"
                />
              </div>
            </div>
            <div v-if="model.hasTwoYearsPassed" class="col-md-6">
              <validation-provider v-slot="{ errors }" :rules="'required'">
                <div v-if="isReadOnly">
                  <label class="data-title mb-0">
                    Lugar de Trabajo:
                  </label>
                  <span class="data-content d-block text-justify">
                    {{ model.workPlacePublicOfficial | empty }}
                  </span>
                </div>
                <custom-input
                  v-else
                  id="work-place-public-offic-input"
                  v-model="model.workPlacePublicOfficial"
                  class="custom-input-con"
                  custom-error-msg="Lugar de trabajo es requerido."
                  :error="errors[0]"
                  label="Lugar de Trabajo:"
                  placeholder="Escriba lugar de trabajo"
                />
              </validation-provider>
            </div>
            <div v-if="model.hasTwoYearsPassed" class="col-md-6">
              <validation-provider v-slot="{ errors }" :rules="'required'">
                <div v-if="isReadOnly">
                  <label class="data-title mb-0">
                    Título de Puesto:
                  </label>
                  <span class="data-content d-block text-justify">
                    {{ model.jobTitlePublicOfficial | empty }}
                  </span>
                </div>
                <custom-input
                  v-else
                  id="job-title-public-offic-input"
                  v-model="model.jobTitlePublicOfficial"
                  class="custom-input-con"
                  custom-error-msg="Título de puesto es requerido."
                  :error="errors[0]"
                  label="Título de Puesto:"
                  placeholder="Escriba título de puesto"
                />
              </validation-provider>
            </div>
            <div v-if="model.hasTwoYearsPassed" class="col-md-6">
              <validation-provider
                v-slot="{ errors }"
                name="terminationDate"
                rules="required"
              >
                <label class="data-title mb-0">Fecha de Terminación:</label>
                <custom-date-picker
                  v-model="model.terminationDate"
                  :class-container="'w-100'"
                  :custom-error-msg="'La fecha de terminación es requerida.'"
                  :disabled="isReadOnly"
                  :error="errors[0]"
                  format="dd/MMM./yyyy"
                  placeholder="DD/MM/YYYY"
                />
              </validation-provider>
            </div>
          </div>
          <div class="col-12">
            <hr class="w-98 ml-0" />
          </div>
        </div>
        <div
          class="mt-3 mb-3 align-items-center d-flex justify-content-end mr-4"
        >
          <action-button
            v-if="!isReadOnly"
            id="btnCancel"
            :disabled="isReadOnly"
            i="fas fa-times-circle"
            text="Cancelar"
            variant="outline-danger mr-3 pl-3 pr-4"
            @click="onCancel"
          />
          <action-button
            v-if="!isReadOnly"
            id="btnSave"
            i="fas fa-flag pr-2"
            text="Someter"
            variant="success px-3"
            @click="onSaveHandler"
          />
        </div>
        <div class="col-12">
          <custom-modal
            cancel-text="Cancelar"
            icon="fas fa-exclamation-circle"
            is-centered
            :save-icon="'fas fa-flag pr-2'"
            save-text="Someter"
            show-cancel
            show-save
            title="Someter"
            :value="showModal"
            width="850px"
            @cancel="onCancelAcceptTermHandler"
            @save="onSubmit"
          >
            <custom-checkbox-single-option
              id="custom-checkbox-acceptedTerms"
              v-model="acceptedTerms"
              class="font-16"
              option-text="Acepto los términos y responsabilidades"
              title="Certifico que la información ofrecida es cierta y correcta"
            />
          </custom-modal>
        </div>
      </ValidationObserver>
    </div>
  </div>
</template>

<script>
import CustomError from 'custom-error';
import IconView from 'icon-view';
import ActionButton from 'ActionButton';
import CustomModal from 'CustomModal';
import CustomCheckboxSingleOption from 'custom-checkbox-single-option';
import RadioButton from '@/components/common/CustomRadioButton';
import CustomInput from 'CustomInput';
import CustomFileInput from 'CustomFileInput';
import CustomCallout from 'custom-callout';
import CheckBox from 'CheckBox';
import CustomDatePicker from 'custom-date-picker';
import { submitPublicOfficials as _submitPublicOfficials } from '@/services/provider/provider-question.js';
import { downloadDocumentByAttachmentId as _downloadDocumentByAttachmentId } from '@/services/common/document.api.js';
import objectToFormData from 'object-to-formdata';
import providerQuestionSection from '@/utils/constants/providerQuestionSection';
import alertMixin from '@quisit/mipe-utils/mixins/alert.mixin.js';
import providerProfileStates from '@/utils/constants/ProviderProfileStates';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import { getByParameterName } from '@/services/common/sysparameter.api';

export default {
  name: 'PublicOfficialsSection',
  components: {
    CustomError,
    IconView,
    ActionButton,
    CustomModal,
    CustomCheckboxSingleOption,
    ValidationObserver,
    ValidationProvider,
    RadioButton,
    CustomInput,
    CustomFileInput,
    CustomCallout,
    CheckBox,
    CustomDatePicker,
  },
  mixins: [alertMixin],
  async mounted() {
    if (
      [
        providerProfileStates.Submitted,
        providerProfileStates.Approved,
        providerProfileStates.Denied,
      ].includes(this.statusId)
    ) {
      if (this.questions && this.questions.length > 0) {
        this.questionsData = this.questions.map((item) => ({
          ...item,
          answer: item.answers?.[0]?.answer || '',
        }));

        // prettier-ignore
        this.model.isActiveEducationDept = this.findAnswerBySortOrder(1, 'answerBool');
        // prettier-ignore
        this.model.isActiveOtherDept = this.findAnswerBySortOrder(2, 'answerBool');
        // prettier-ignore
        this.model.isFormerPublicOfficial = this.findAnswerBySortOrder(3, 'answerBool');
        // prettier-ignore
        this.model.workPlaceEducationDept = this.findAnswerBySortOrder(1, 'workPlace');
        // prettier-ignore
        this.model.jobTitleEducationDept = this.findAnswerBySortOrder(1, 'jobTitle');
        // prettier-ignore
        this.model.workPlaceOtherDept = this.findAnswerBySortOrder(2, 'workPlace');
        // prettier-ignore
        this.model.jobTitleOtherDept = this.findAnswerBySortOrder(2, 'jobTitle');
        // prettier-ignore
        this.model.workPlacePublicOfficial = this.findAnswerBySortOrder(3, 'workPlace');
        // prettier-ignore
        this.model.jobTitlePublicOfficial = this.findAnswerBySortOrder(3, 'jobTitle');
        // prettier-ignore
        this.model.hasTwoYearsPassed = this.findAnswerBySortOrder(3, 'hasTwoYearsPassed');
        // prettier-ignore
        this.model.terminationDate = this.findAnswerBySortOrder(3, 'terminationDate');

        // prettier-ignore
        this.model.dispensaDocumentFileId = this.findAnswerBySortOrder(2, 'dispensaDocumentFileId');
        // prettier-ignore
        this.dispensaDocument.filename = this.findAnswerBySortOrder(2, 'dispensaDocumentFileName');
        // prettier-ignore
        this.model.dispensaDocumentSecretaryFileId = this.findAnswerBySortOrder(1, 'dispensaDocumentFileId');
        // prettier-ignore
        this.dispensaDocumentSecretary.filename = this.findAnswerBySortOrder(1, 'dispensaDocumentFileName');
      }
    } else {
      this.questionsData = this.questions.map((item) => ({
        ...item,
        answer: '',
      }));
    }
    await this.showSecretaryDispensaParameter();
  },
  data: () => ({
    questionsData: [],
    showModal: false,
    acceptedTerms: false,
    model: {
      isActiveEducationDept: null,
      isActiveOtherDept: null,
      isFormerPublicOfficial: null,
      workPlaceEducationDept: null,
      jobTitleEducationDept: null,
      workPlaceOtherDept: null,
      jobTitleOtherDept: null,
      workPlacePublicOfficial: null,
      jobTitlePublicOfficial: null,
      isNotApplyChecked: false,
      hasTwoYearsPassed: null,
      terminationDate: null,
    },
    dispensaDocument: {
      attachment: null,
      filename: null,
    },
    dispensaDocumentSecretary: {
      attachment: null,
      filename: null,
    },
    attemptedSaveHandler: false,
    attemptedTwoYearsSaveHandler: false,
    showSecretaryDispensa: false,
  }),
  computed: {
    isReadOnly() {
      return (
        this.statusId == providerProfileStates.Submitted ||
        this.statusId == providerProfileStates.Approved
      );
    },
    isPending() {
      return this.statusId == providerProfileStates.Pending;
    },
    isDenied() {
      return this.statusId == providerProfileStates.Denied;
    },
    hasValidFileName() {
      return (
        this.dispensaDocument.filename !== undefined &&
        this.dispensaDocument.filename !== null
      );
    },
    hasValidSecretaryFileName() {
      return (
        this.dispensaDocumentSecretary.filename !== undefined &&
        this.dispensaDocumentSecretary.filename !== null
      );
    },
    documentName() {
      return this.dispensaDocument.filename?.split('.pdf')[0] ?? '';
    },
    optionsHasTwoYearsPassed() {
      return {
        options: [
          {
            id: true,
            label: 'SI',
            check: this.model.hasTwoYearsPassed === true,
            disabled: false,
          },
          {
            id: false,
            label: 'NO',
            check: this.model.hasTwoYearsPassed === false,
            disabled: false,
          },
        ],
      };
    },
    getErrorMessageForQuestion() {
      let errors = {};

      if (
        this.model.isActiveEducationDept === null ||
        this.model.isActiveEducationDept === undefined
      ) {
        errors[1] = 'Favor marcar Si o No.';
      }
      if (
        this.model.isActiveOtherDept === null ||
        this.model.isActiveOtherDept === undefined
      ) {
        errors[2] = 'Favor marcar Si o No.';
      }
      if (
        this.model.isFormerPublicOfficial === null ||
        this.model.isFormerPublicOfficial === undefined
      ) {
        errors[3] = 'Favor marcar Si o No.';
      }

      return errors;
    },
    showErrorHasTwoYearsPassed() {
      return (
        this.model.isFormerPublicOfficial &&
        (this.model.hasTwoYearsPassed === null ||
          this.model.hasTwoYearsPassed === undefined)
      );
    },
    getDynamicQuestion() {
      return (question) => {
        let prefix = '';
        if (this.providerTypeId === 2) {
          prefix =
            'El dueño de la corporación o alguno de los miembros de la junta de directores';
        } else if (this.providerTypeId === 3) {
          prefix = 'El proveedor';
        }
        return question.replace(/El proveedor/gi, prefix);
      };
    },
  },
  props: {
    providerId: {
      type: Number,
      default: () => 0,
    },
    statusId: {
      type: Number,
      default: () => 0,
    },
    sectionTitle: {
      type: String,
      default: () => '',
    },
    questions: {
      type: Array,
      default: () => [],
    },
    sectionDescription: {
      type: String,
      default: () => '',
    },
    providerTypeId: {
      type: Number,
      default: () => 0,
    },
    biddingAcademicYearId: {
      type: Number,
      default: () => 0,
    },
  },
  methods: {
    findAnswerBySortOrder(sortOrder, fieldName) {
      const question = this.questionsData.find(
        (q) => q.sortOrder === sortOrder
      );
      if (question) {
        const fieldValue = question.answers?.[0]?.[fieldName];
        return fieldValue !== undefined ? fieldValue : null;
      }
      return null;
    },
    clean() {
      this.questionsData = [];
      this.showModal = false;
      this.acceptedTerms = false;
      this.model = {
        isActiveEducationDept: null,
        isActiveOtherDept: null,
        isFormerPublicOfficial: null,
        workPlaceEducationDept: null,
        jobTitleEducationDept: null,
        workPlaceOtherDept: null,
        jobTitleOtherDept: null,
        workPlacePublicOfficial: null,
        jobTitlePublicOfficial: null,
        dispensaDocumentFileId: null,
        dispensaDocumentSecretaryFileId: null,
        isNotApplyChecked: false,
        hasTwoYearsPassed: null,
        terminationDate: null,
      };
    },
    getFileRules({ id }, item) {
      if (
        [
          providerProfileStates.Submitted,
          providerProfileStates.Approved,
          providerProfileStates.Denied,
        ].includes(this.statusId)
      ) {
        return item?.filename ? '' : 'required';
      } else {
        if (!id || (id && !item?.filename)) {
          return 'required';
        }

        return '';
      }
    },
    getOptions(sortOrder) {
      switch (sortOrder) {
        case 1:
          return {
            options: [
              {
                id: true,
                label: 'SI',
                check: this.model.isActiveEducationDept === true,
                disabled: false,
              },
              {
                id: false,
                label: 'NO',
                check: this.model.isActiveEducationDept === false,
                disabled: false,
              },
            ],
          };
        case 2:
          return {
            options: [
              {
                id: true,
                label: 'SI',
                check: this.model.isActiveOtherDept === true,
                disabled: false,
              },
              {
                id: false,
                label: 'NO',
                check: this.model.isActiveOtherDept === false,
                disabled: false,
              },
            ],
          };
        case 3:
          return {
            options: [
              {
                id: true,
                label: 'SI',
                check: this.model.isFormerPublicOfficial === true,
                disabled: false,
              },
              {
                id: false,
                label: 'NO',
                check: this.model.isFormerPublicOfficial === false,
                disabled: false,
              },
            ],
          };
        default:
          return {
            options: [
              {
                id: true,
                label: 'SI',
                disabled: false,
              },
              {
                id: false,
                label: 'NO',
                disabled: false,
              },
            ],
          };
      }
    },
    onChange(value, questionId) {
      const question = this.questionsData.find((q) => q.id === questionId);
      if (!question) return;

      switch (question.sortOrder) {
        case 1:
          this.model.isActiveEducationDept = value.id;
          break;
        case 2:
          this.model.isActiveOtherDept = value.id;
          break;
        case 3:
          this.model.isFormerPublicOfficial = value.id;
          break;
      }
    },
    onChangeHasTwoYearsPassed(item) {
      this.model.hasTwoYearsPassed = item.id;
    },
    onDownloadFile(id) {
      _downloadDocumentByAttachmentId(id).catch((err) => {
        this.ShowToast('Alerta', err.response.data.message || 'error', 'error');
      });
    },
    async onChangeDispensaFile(file) {
      this.dispensaDocument.attachment = file;
      this.dispensaDocument.filename = file?.name;
    },
    async onChangeDispensaFileSecretary(file) {
      this.dispensaDocumentSecretary.attachment = file;
      this.dispensaDocumentSecretary.filename = file?.name;
    },
    async onCancel() {
      if (this.statusId != providerProfileStates.Denied) {
        const answer = await this.ShowCancelModal(
          'Confirmación',
          `¿Está seguro de que desea cancelar? Si cancela, se borrarán todos los datos que ha llenado en esta sección.`,
          'Sí',
          'No'
        );

        if (answer) {
          this.clean();
          this.$emit('on-cancel');
        } else {
          return;
        }
      } else {
        this.$emit('on-cancel');
      }
    },
    async onSaveHandler() {
      this.attemptedSaveHandler = true;
      this.attemptedTwoYearsSaveHandler = this.showErrorHasTwoYearsPassed;
      const isValid = await this.$refs.publicOfficialsValidationObserver.validate();
      const hasCustomErrors =
        Object.keys(this.getErrorMessageForQuestion).length > 0 ||
        this.showErrorHasTwoYearsPassed;

      if (isValid && !hasCustomErrors) {
        this.showModal = true;
      } else {
        this.ShowToast('Alerta', 'Información Incompleta', 'error');
        return;
      }
    },
    async onCancelAcceptTermHandler() {
      this.showModal = false;
      this.acceptedTerms = false;
    },
    async onSubmit() {
      if (!this.acceptedTerms) {
        this.ShowToast(
          'Alerta',
          'Favor aceptar los términos y responsabilidades.',
          'error'
        );
        return;
      }

      const payload = {
        sectionId: providerQuestionSection.PublicOfficialsSection,
        providerId: this.providerId,
        academicYearId: this.biddingAcademicYearId,
        statusId: providerProfileStates.Submitted,
        dispensaDocumentFile: this.dispensaDocument?.attachment,
        dispensaDocumentSecretaryFile: this.dispensaDocumentSecretary
          ?.attachment,
        answers: this.questionsData.map((item) => {
          let answerBool = false;
          let workPlace = '';
          let jobTitle = '';
          let hasTwoYearsPassed = false;
          let terminationDate = null;
          let dispensaDocumentFileId = null;
          let dispensaDocumentFileName = '';
          let dispensaDocumentSecretaryFileId = null;
          let dispensaDocumentSecretaryFileName = '';

          if (item.sortOrder === 1) {
            answerBool = this.model.isActiveEducationDept;
            workPlace = this.model.workPlaceEducationDept;
            jobTitle = this.model.jobTitleEducationDept;
            dispensaDocumentFileId = this.model.dispensaDocumentSecretaryFileId;
            dispensaDocumentFileName = this.dispensaDocumentSecretary?.filename;
          } else if (item.sortOrder === 2) {
            answerBool = this.model.isActiveOtherDept;
            workPlace = this.model.workPlaceOtherDept;
            jobTitle = this.model.jobTitleOtherDept;
            dispensaDocumentFileId = this.model.dispensaDocumentFileId;
            dispensaDocumentFileName = this.dispensaDocument?.filename;
          } else if (item.sortOrder === 3) {
            answerBool = this.model.isFormerPublicOfficial;
            workPlace = this.model.workPlacePublicOfficial;
            jobTitle = this.model.jobTitlePublicOfficial;
            if (this.model.isFormerPublicOfficial) {
              hasTwoYearsPassed = this.model.hasTwoYearsPassed;
              terminationDate = this.model.terminationDate;
            }
          }

          return {
            questionId: item.id,
            answer: item.answer,
            answerBool: answerBool,
            workPlace: workPlace,
            jobTitle: jobTitle,
            hasTwoYearsPassed: hasTwoYearsPassed,
            terminationDate: terminationDate,
            dispensaDocumentFileId: dispensaDocumentFileId,
            dispensaDocumentFileName: dispensaDocumentFileName,
            dispensaDocumentSecretaryFileId: dispensaDocumentSecretaryFileId,
            dispensaDocumentSecretaryFileName: dispensaDocumentSecretaryFileName,
          };
        }),
      };

      let dataToSend = objectToFormData(payload, {
        indices: true,
        nullsAsUndefineds: true,
      });

      const { data: response } = await _submitPublicOfficials(dataToSend);
      if (response) {
        this.ShowToast(
          'Confirmación',
          'El estatus ha sido actualizado exitosamente.',
          'success'
        );
        this.$emit('on-save');
      } else {
        this.ShowToast('Error', response?.data?.message || 'error', 'error');
      }

      this.showModal = false;
      this.acceptedTerms = false;
    },
    async onChangeIsNotApplyChecked(value) {
      if (!value) {
        this.dispensaDocument = {
          attachment: null,
          filename: null,
        };
        this.model.dispensaDocumentFileId = null;
      }
    },
    async showSecretaryDispensaParameter() {
      const { data } = await getByParameterName('RP_ShowSecretaryDispensa');
      if (data) {
        this.showSecretaryDispensa = data.value === 'true';
      }
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep .custom-icon {
  .dot {
    box-shadow: none !important;
    margin-right: 4px !important;
  }
  .dot.dot--has-border {
    border-color: transparent !important;
  }
  .color-gray-7.font-16.font-weight-bold {
    color: #11291b !important;
  }
}
.custom-radio-container > span:first-of-type {
  height: 100% !important;
}
.radio-button-container {
  height: 100%;
  align-items: unset !important;
}
.radio-button-container >>> .custom-radio-button {
  margin-right: 0;
  margin-left: 8px;
}
::v-deep .custom-radio-container {
  .read-only .pointer {
    cursor: default;
  }
}
</style>
